var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "ss-material-picture" }, [
      _c(
        "div",
        { staticClass: "left-wrap" },
        [
          _c(
            "el-button",
            {
              staticClass: "m-r-20",
              nativeOn: {
                click: function ($event) {
                  return _vm.uploadVideo.apply(null, arguments)
                },
              },
            },
            [_vm._v("上传视频")]
          ),
          _c(
            "span",
            {
              staticClass: "ss-material-button",
              on: {
                click: function ($event) {
                  return _vm.gotoMaterial()
                },
              },
            },
            [_vm._v("前往素材中心")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-wrap" },
        [
          _c("i", {
            staticClass: "el-icon-s-fold",
            class: { active: _vm.listType === "list" },
            on: {
              click: function ($event) {
                return _vm.changeListType("list")
              },
            },
          }),
          _c("i", {
            staticClass: "el-icon-menu",
            class: { active: _vm.listType === "card" },
            on: {
              click: function ($event) {
                return _vm.changeListType("card")
              },
            },
          }),
          _c("el-input", {
            attrs: { placeholder: "视频名称", "prefix-icon": "el-icon-search" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.init()
              },
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "search",
            },
          }),
          _c("el-button", {
            staticClass: "m-l-10",
            attrs: { icon: "el-icon-refresh", type: "text" },
            on: {
              click: function ($event) {
                return _vm.handleCurrentChange(1)
              },
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "ss-material-main" }, [
      _c("div", { staticClass: "ss-material-main-left" }, [
        _c(
          "div",
          { staticClass: "ss-material-main-tree" },
          [
            _c("AppTree", {
              staticStyle: { width: "200px" },
              attrs: { loading: _vm.treeLoading, nobtn: true },
              on: { "node-click": _vm.treeClick },
              model: {
                value: _vm.classlist,
                callback: function ($$v) {
                  _vm.classlist = $$v
                },
                expression: "classlist",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "ss-material-main-right",
        },
        [
          _c("div", { staticClass: "content-wrap" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listType === "card",
                    expression: "listType === 'card'",
                  },
                ],
                staticClass: "card-pattern-list-wrap",
              },
              [
                _vm.tableData.length > 0
                  ? _c(
                      "div",
                      { staticClass: "check" },
                      [
                        _c("el-checkbox", {
                          attrs: { indeterminate: _vm.isIndeterminate },
                          model: {
                            value: _vm.checkAll,
                            callback: function ($$v) {
                              _vm.checkAll = $$v
                            },
                            expression: "checkAll",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-checkbox-group",
                  {
                    on: { change: _vm.handleCheckedChange },
                    model: {
                      value: _vm.valueIds,
                      callback: function ($$v) {
                        _vm.valueIds = $$v
                      },
                      expression: "valueIds",
                    },
                  },
                  _vm._l(_vm.tableData, function (item) {
                    return _c(
                      "div",
                      { key: item.materialId, staticClass: "picture-card" },
                      [
                        _c("div", { staticClass: "content" }, [
                          _c("img", {
                            attrs: {
                              src: item.materialFrameUrl,
                              alt: item.materialName,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.playVideo(item)
                              },
                            },
                          }),
                          _c("div", { staticClass: "resolution" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("filterTime")(item.materialDes)) +
                                " "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "detail" }, [
                          _c(
                            "div",
                            { staticClass: "title-wrap" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { label: item },
                                  on: {
                                    change: (res) =>
                                      _vm.handleCheckedChange(res, item),
                                  },
                                },
                                [
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v(
                                      " " + _vm._s(item.materialName) + " "
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "common-row" }, [
                            _vm._v(_vm._s(item.createTime)),
                          ]),
                          _c("div", { staticClass: "common-row" }, [
                            _vm._v(
                              _vm._s(_vm._f("filterSize")(item.materialSize))
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listType === "list",
                    expression: "listType === 'list'",
                  },
                ],
                staticClass: "table-wrap",
              },
              [
                _c(
                  "div",
                  { staticClass: "header-wrap" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        staticStyle: { width: "666px" },
                        attrs: {
                          height: "360",
                          data: _vm.tableData,
                          "tooltip-effect": "dark",
                          "header-cell-style": {
                            background: "#f5f5f5",
                            padding: "0",
                          },
                          "row-key": (row) => row.materialId,
                        },
                        on: {
                          "selection-change": _vm.handleTableSelectionChange,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            "reserve-selection": true,
                            width: "55",
                            selectable: _vm.selectable,
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "materialName", label: "视频" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _vm.type === "2"
                                    ? _c("div", { staticClass: "fl fl_ai_c" }, [
                                        _c("div", { staticClass: "videoImg" }, [
                                          _c("img", {
                                            attrs: {
                                              src: row.materialFrameUrl,
                                              alt: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.playVideo(row)
                                              },
                                            },
                                          }),
                                        ]),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "m-l-10 text_hidden",
                                            attrs: { title: row.materialName },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(row.materialName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "materialDes",
                            label: "时长",
                            width: "120",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("filterTime")(row.materialDes)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "materialSize",
                            width: "80",
                            label: "大小",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("filterSize")(row.materialSize)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "createTime",
                            width: "160",
                            label: "上传时间",
                            "show-overflow-tooltip": "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div"),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next",
                  total: _vm.total,
                  "current-page": _vm.current,
                  "page-size": _vm.size,
                },
                on: {
                  "update:currentPage": function ($event) {
                    _vm.current = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.current = $event
                  },
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }